export default "__VITE_ASSET__792be61f__"